module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.methods,
      "outlined": "",
      "label": "Select method"
    },
    model: {
      value: (_vm.method),
      callback: function($$v) {
        _vm.method = $$v
      },
      expression: "method"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "URL",
      "outlined": "",
      "placeholder": "URL"
    },
    model: {
      value: (_vm.url),
      callback: function($$v) {
        _vm.url = $$v
      },
      expression: "url"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('h3', [_vm._v("Header options")]), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
    return _c('v-row', {
      key: header.key
    }, [_c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('v-text-field', {
      attrs: {
        "outlined": "",
        "hide-details": "",
        "label": "Name",
        "placeholder": "Name"
      },
      model: {
        value: (header.key),
        callback: function($$v) {
          _vm.$set(header, "key", $$v)
        },
        expression: "header.key"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      attrs: {
        "outlined": "",
        "hide-details": "",
        "label": "Value",
        "placeholder": "Value"
      },
      model: {
        value: (header.value),
        callback: function($$v) {
          _vm.$set(header, "value", $$v)
        },
        expression: "header.value"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('v-btn', {
      staticClass: "ma-2",
      attrs: {
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.removeHeader(index)
        }
      }
    }, [_vm._v("Remove")])], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.addHeader()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "input-7-1",
      "label": "Body"
    },
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": _vm.testAPI
    }
  }, [_vm._v("Send Request")])], 1)], 1)], 2), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-row', [_c('v-col', [_c('v-alert', {
    attrs: {
      "type": _vm.response.type
    }
  }, [_vm._v(_vm._s(_vm.response.text))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "input-7-1",
      "label": "Response",
      "readonly": ""
    },
    model: {
      value: (_vm.response.data),
      callback: function($$v) {
        _vm.$set(_vm.response, "data", $$v)
      },
      expression: "response.data"
    }
  })], 1)], 1)], 1)], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "align": "center"
    }
  }, [_c('h3', [_vm._v("API Testing")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc1d394"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Development/API/Testing.vue
// module id = 2180
// module chunks = 0